module.exports = __webpack_public_path__ + "static/hero-analytics-8c22ec16df85c2a8139ed5dce3eaf4dc.svg";